// Domain Model
import { File } from ".";

const extractRole = worker => {
  if (worker.role) return worker.role;
  if (Array.isArray(worker.roles) && worker.roles.length > 0) {
    const r = worker.roles[0];
    return { id: r.id, name: r.name };
  }
  return null;
};

export class Worker {
  constructor(worker = {}) {
    this.id = worker.id;
    this.email = worker.email;
    this.firstName = worker.first_name;
    this.lastName = worker.last_name;
    this.contactNumber = worker.contact_number;
    this.profileImage = new File(worker.profile_image);
    this.role = extractRole(worker);
    this.fullName = this.fullName();
  }

  fullName() {
    return `${this.firstName} ${this.lastName}`;
  }
}
